module.exports = __webpack_public_path__ + "static/media/logos_squares_Gold_Midea.f0d82181.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Gold_Midea.png
// module id = 85
// module chunks = 0